export function assertString(value: string | null | undefined): string {
  if (value === null || value === undefined) {
    throw new Error(`Expected value to be string, bug got "${typeof value}" instead`);
  }

  return value;
}
